<template>
    <div
        class="relative grid grid-cols-12 gap-6 image-text-component container w-full col-span-full"
        ref="elementRef"
    >
        <div
            class="md:!col-start-auto h-auto object-cover col-span-full md:col-span-7 order rounded-sm self-center [.image-text-component:nth-of-type(even)_&]:md:order-4"
        >
            <ResponsiveMedia
                :media-id="mediaId"
                :kind="kind"
                :asset-id="assetId"
                :autoplay="content?.autoplays"
                :loop="content?.autoplays"
                :muted="content?.autoplays"
                :playing="content?.autoplays"
                :controls="!content?.autoplays"
                css-class="object-cover w-full h-full ease-in-out"
            />
        </div>
        <div aria-hidden="true" class="col-span-1 [.image-text-component:nth-of-type(even)_&]:md:order-2 [.image-text-component:nth-of-type(even)_&]:lg:order-1"></div>
        <div aria-hidden="true" class="col-span-1 hidden [.image-text-component:nth-of-type(even)_&]:lg:block [.image-text-component:nth-of-type(even)_&]:lg:order-3"></div>
        <div class="flex flex-col gap-8 justify-center col-span-full md:col-span-4 lg:col-span-3 [.image-text-component:nth-of-type(even)_&]:md:order-1 [.image-text-component:nth-of-type(even)_&]:lg:order-2">
            <div :lang="mainStore.active_locale === 'nl_NL' ? 'nl' : 'en'" class="view-h3 font-medium hyphens-auto">{{get_localized_value(content?.title)}}</div>
            <div class="text-body">
                <RenderedHTML :value="content?.['body']" />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import RenderedHTML from '~/components/view/RenderedHTML.vue'
import ResponsiveMedia from '~/components/ResponsiveMedia.vue'
import type { MediaKind } from '#layers/cms/shared/types/MediaBucket'
import type { JSONContent } from '@tiptap/vue-3'

const props = defineProps({
    content: {
        type: Object as PropType<{ title?: unknown, body?: JSONContent, media?: string, autoplays?: boolean }>,
    },
    properties: {
        type: Array as PropType<{translate: boolean, label: string}[]>
    },
    // Set by legacy video-with-text-block / image-with-text-block wrappers, which already know
    // their content's kind statically and pass a raw b-video/b-image id that predates b-media.
    // New content created straight against this component leaves these unset and relies on
    // `content.media` (a b-media pointer) instead — see ResponsiveMedia.vue.
    kind: {
        type: String as PropType<MediaKind>,
        default: undefined,
    },
    assetId: {
        type: String,
        default: undefined,
    },
})
const mediaId = computed(() => props.kind ? undefined : props.content?.media)

const mainStore = useMainStore()
const {get_value: get_localized_value} = useLocalizedValue()

const emit = defineEmits(['enter', 'leave'])

const { elementRef, isInViewport } = useInViewport({
    threshold: 0.5,
    onEnter: () => emit('enter'),
    onLeave: () => emit('leave'),
})

</script>
